<template>
    <div>
            <div class="input-group mb-3" id="search_string">
                <input style="border-radius: 0rem;" type="text" v-on:keyup="searchUser()"  v-model="searchString.name" class="form-control" :placeholder="$t('name')" :aria-label="$t('search')" >
                <div class="input-group-append">
                    <button type="submit" class="btn btn-primary" id="users-search-button"><i class="fa fa-search"></i></button>
                    <a class="btn btn-success" href="#" v-on:click.prevent="advancedSearch=!advancedSearch"><i class="fa fa-cog fa-1x"></i></a>
                </div>
            </div>

            <b-card v-show="advancedSearch"  class="mb-2" >
                <b-row><b-col>Год рождения: <b-form-input v-model="searchString.birthyear" type="number" placeholder="Введите год" /></b-col>
                    <b-col>Страна: <b-form-input v-model="searchString.country" type="text" placeholder="Введите страну" /></b-col></b-row>
                Интересы: 
                <v-select :filterable="false" :options="areas" label="name" taggable multiple  v-model="searchString.interests" @search="getOptions">
                    <template slot="no-options">
                        Ничего не найдено 
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.name }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center" >
                            {{ option.name }}
                        </div>
                    </template>
                </v-select>
                Навыки: 
                <v-select :filterable="false" :options="skills" label="name" taggable multiple  v-model="searchString.skills" @search="getSkills">
                    <template slot="no-options">
                        Ничего не найдено
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.name }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center" >
                            {{ option.name }}
                        </div>
                    </template>
                </v-select>
                Организация: 
                <v-select :filterable="false" :options="organizations" label="name" taggable  v-model="searchString.organization" @search="getOrganization">
                    <template slot="no-options">
                        Ничего не найдено
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.name }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center" >
                            {{ option.name }}
                        </div>
                    </template>
                </v-select>

            </b-card>
            <div class="row"> 
                <b-tabs pills v-model="tabIndex" style="padding-right: 0px; padding-left: 0px; width: 100%;">
                    <b-tab @click="tab = 'all'">
                        <template slot="title">
                            <i class="px-nav-icon fa fa-star" ></i>{{ $t('all') }}
                        </template>
                    </b-tab>
                    <b-tab @click="tab = 'friends'">
                        <template slot="title">
                            <i class="px-nav-icon fa fa-home" href="#" ></i>{{ $t('friends') }}
                        </template>
                    </b-tab>
                    <b-tab @click="tab = 'followers'">
                        <template slot="title">
                            <i class="px-nav-icon fa fa-home"></i>{{ $t('sub') }}
                        </template>
                    </b-tab>
                    <b-tab @click="tab = 'following'">
                        <template slot="title">
                            <i class="px-nav-icon fa fa-home" ></i>{{ $t('inter') }}
                        </template>
                    </b-tab>

                    <UsersList ref="usersList" :tab="tab" :searchString="string" v-on:toAll="toAll"></UsersList>
                </b-tabs>

            </div>
    </div>
</template>


<i18n>
    {
    "en": {
    "search": "Advanced search",
    "friends": "Friends",
    "sub": "Followers",
    "inter": "Interesting pages",
    "all": "All",
    "country": "Country - country selection",
    "name": "Type name",
    "search": "Advanced search",
    "sity": "City - city selection",
    "area": "Scientific interests - the choice of available",
    "skills": "Skills - choice of available",
    "degree": "Academic degree"
    },
    "ru": {
    "search": "Расширенный поиск",
    "friends": "Друзья",
    "sub": "Подписчики",
    "inter": "Интересные страницы",
    "all": "Все",
    "cont": "Страна - выбор страны",
    "name": "Начните вводить любое имя",
    "search": "Расширенный поиск",
    "sity": "Город - выбор города",
    "area": "Научные интересы - выбор из имеющихся",
    "skills": "Навыки - выбор из имеющихся",
    "degree": "Ученая степень - кандидат наук, доктор наук"
    }
    }
</i18n>











<script>
    const debounce = function (f, ms) {
        let timer = null;
        return function (...args) {
            const onComplete = () => {
                f.apply(this, args);
                timer = null;
            }
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(onComplete, ms);
        };
    }
    import UsersList from './users_list'
    import vSelect from 'vue-select'
    export default {
        name: 'events',
        components: {
            UsersList,
            vSelect
        },
        data() {
            return {
                advancedSearch: false,
                searchString: {
                    name: '',
                    birthyear: null,
                    country: null,
                    interests: null,
                    skills: null,
                    organization: null
                },
                tab: 'all',
                tabIndex: 0,
                areas: [],
                skills: [],
                organizations: [],
            }
        },
        computed: {
            'string': function () {
                var output = {};
                Object.assign(output, this.searchString)
                output.interests = JSON.stringify(output.interests)
                output.skills = JSON.stringify(output.skills)
                return output;
            }
        },
        methods: {
            searchUser() {
                this.$refs.usersList.search();
            },
            toAll() {
                this.tab = 'all'
                this.tabIndex = 3

            },
            getOptions(search, loading) {
                loading(true)
                this.search(loading, search, this);
            },
            search: debounce(function (loading, search, vm) {
                vm.$http.get('event/get-areas?q=' + search)
                        .then(response => vm.$set(vm, 'areas', response.data.results));
                loading(false)
            }, 350),
            getSkills(search, loading) {
                loading(true)
                this.searchSkills(loading, search, this);
            },
            searchSkills: debounce(function (loading, search, vm) {
                vm.$http.get('user/get-skills?q=' + search)
                        .then(response => vm.$set(vm, 'skills', response.data.results));
                loading(false)
            }, 350),
            getOrganization(search, loading) {
                loading(true)
                this.searchOrganization(loading, search, this);
            },
            searchOrganization: debounce(function (loading, search, vm) {
                vm.$http.get('user/get-organization?q=' + search)
                        .then(response => vm.$set(vm, 'organizations', response.data.results));
                loading(false)
            }, 350),
        }
    }
</script>
